import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TripGenerationLoader: React.FC = () => {
  const [textIndex, setTextIndex] = useState(0);
  
  const loadingTexts = [
    "Crafting Your Perfect Itinerary...",
    "Finding hidden gems...",
    "Checking weather forecasts...",
    "Locating best hotels...",
    "Optimizing travel routes..."
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prev) => (prev + 1) % loadingTexts.length);
    }, 2500); // Change text every 2.5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    // Positioned below the header (top-20 / 80px) to keep header visible
    <div className="fixed top-[80px] md:top-[88px] bottom-0 left-0 right-0 z-40 flex flex-col items-center justify-center bg-white/95 backdrop-blur-sm">
      <div className="relative w-full max-w-md p-8 flex flex-col items-center -mt-20">
        
        {/* Animated Globe/Plane Icon */}
        <div className="relative w-40 h-40 mb-10">
          {/* Pulsing Background */}
          <motion.div 
            className="absolute inset-0 bg-primary-100 rounded-full"
            animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.5, 0.3] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          />
          
          {/* Globe Emoji */}
          <div className="absolute inset-0 flex items-center justify-center text-7xl">
            🌍
          </div>

          {/* Orbiting Plane */}
          <motion.div
            className="absolute inset-0"
            animate={{ rotate: 360 }}
            transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
          >
            {/* Plane positioned at the top (12 o'clock) */}
            {/* To fly clockwise (Right), it needs to point Right (90deg) */}
            {/* If using an SVG pointing UP by default, we rotate it 90deg */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 transform">
               <svg 
                 xmlns="http://www.w3.org/2000/svg" 
                 viewBox="0 0 24 24" 
                 fill="currentColor" 
                 className="w-10 h-10 text-primary-600 drop-shadow-lg transform rotate-90"
               >
                 <path d="M3.478 2.405a.75.75 0 00-.926.94l2.432 7.905H13.5a.75.75 0 010 1.5H4.984l-2.432 7.905a.75.75 0 00.926.94 60.519 60.519 0 0018.445-8.986.75.75 0 000-1.218A60.517 60.517 0 003.478 2.405z" />
               </svg>
            </div>
          </motion.div>
        </div>

        {/* Text Animations */}
        <div className="text-center h-20 flex items-center justify-center w-full">
          <AnimatePresence mode="wait">
            <motion.h2 
              key={textIndex}
              className="text-2xl font-bold text-gray-800"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >
              {loadingTexts[textIndex]}
            </motion.h2>
          </AnimatePresence>
        </div>

        {/* Progress Bar */}
        <div className="w-64 h-2 bg-gray-100 rounded-full mt-6 overflow-hidden">
          <motion.div 
            className="h-full bg-gradient-to-r from-primary-400 to-primary-600"
            animate={{ x: ["-100%", "100%"] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>

      </div>
    </div>
  );
};

export default TripGenerationLoader;
